<!--
  由于有新功能需要支持，
  支持只有filiter才请求接口
  重复写DataTablePage
  @author Linmn
-->
<template>
  <div class="main">
    <!-- <h2
      v-if="title"
      class="title">
      {{title}}
    </h2> -->
    <div class="table-top clearfix">
      <ButtonList
        v-if="toolbarList && toolbarList.length > 0"
        class="toolbar"
        :buttonList="toolbarList"
      />
      <slot
        class="customToolbar"
        name="toolbar">
      </slot>
      <FilterBox
        v-if="filterList && filterList.length > 0 && isFilterShow"
        class="filter-box"
        :columns="columnsList"
        :filterList="filterList"
        :filterBy="filterBy"
        @changeFilterBy="changeFilterBy"
      />
    </div>
    <DataTable
      ref="dataTable"
      class="table-wrapper"
      :cid="cid"
      :pid="pid"
      :isTree="isTree"
      :isLoading="isLoading"
      :mainColumn="mainColumn"
      :longColumn="longColumn"
      :clientWidth="clientWidth"
      :clientHeight="clientHeight"
      :tableWrapperWidth="tableWrapperWidth"
      :tableList="tableList"
      :operationList="operationList"
      :operationWidth="operationWidth"
      :columns="columnsList"
      :tableData="tableData"
      :orderBy="orderBy"
      :isExpand="isExpand"
      @checkGroupValue="checkGroupValue"
      @changeOrderBy="changeOrderBy"
      @changeTreeExpands="changeTreeExpands"
    />
    <div class="table-footer">
      <ColumnFilter
        class="column-filter"
        :columnsObject="columnsList"
        :tableList="tableInitList"
        :columnGroupBy="columnGroupBy"
        :tableFullList="tableFullList"
        :openDirection="2"
        @grandSonEvent="afterChangeColumn"
      ></ColumnFilter>
      <div
        class="page"
        v-if="!isTree"
        >
        <slot name="info"></slot>
        <el-pagination
          class="pagination"
          layout="total, sizes, prev, pager, next"
          :page-sizes="[10, 25, 50, 100]"
          :page-size="pageSize"
          :current-page="pageIndex"
          :total="recordsFiltered"
          @size-change="pageSizeChange"
          @current-change="pageIndexChange">
        </el-pagination>
      </div>
    </div>
    <SmartDialog
      v-if="dialogShow"
      v-model="dialogVisible"
      :title="dialogLabel"
      :size="dialogSize">
      <SmartForm
        labelPosition="right"
        btnPosition="center"
        :btnLabel="false"
        :formList="dialogFormList"
        :values="dialogFormValues"
        :columns="columnsList"
        :buttonList="dialogButtonList"
        :formEnterIndex="0"/>
    </SmartDialog>
    <slot></slot>
  </div>
</template>
<script>

import { mapGetters } from 'vuex'
import { pinyinInitial } from 'hanyu-pinyin'
import { cloneDeep } from 'lodash'

import { treeFormat, valueFormat } from '@/utils/common'
import { fetch, fetchList, fetchCreate, fetchUpdate } from '@/utils/api'

import SmartDialog from '@/components/SmartDialog'
import SmartForm from '@/components/SmartForm'
import DataTable from '@/components/DataTable'
import ButtonList from '@/components/ButtonList'
import FilterBox from '@/components/FilterBox'
import ColumnFilter from '@/containers/DataTablePage/columnFilter'
import { expire } from '@/utils/auth'

// import { operationEventUpdate, operationEventDelete } from './operationEvent'

export default {
  name: 'DataTablePageNew',
  components: {
    SmartDialog,
    SmartForm,
    DataTable,
    ButtonList,
    FilterBox,
    ColumnFilter
  },
  props: {
    isTree: {
      type: Boolean,
      default: false
    },
    resource: {
      type: String,
      default: ''
    }, /* 标题英文名 */
    title: {
      type: String,
      default: ''
    }, /* 标题英文名 */
    label: {
      type: String,
      default: 'label'
    }, /* 标题英文名 */
    labelName: {
      type: String,
      default: 'label'
    },
    dialogSize: String,
    toolbar: {
      type: Array,
      default: () => ([])
    },
    operation: {
      type: Array,
      default: () => ([])
    },
    operationWidth: {
      type: Number,
      default: 200
    },
    cid: {
      type: String,
      default: 'id'
    }, /* 页面对话框标题 */
    pid: {
      type: String,
      default: 'pid'
    }, /* 页面对话框标题 */
    mainColumn: {
      type: String,
      default: 'label'
    }, /* 标题英文名 */
    longColumn: {
      type: String,
      default: 'label'
    }, /* 标题英文名 */
    columns: {
      type: Object,
      default: () => ({})
    },
    tableFullList: {
      type: Array,
      default: () => ([])
    },
    tableInitList: {
      type: Array,
      default: () => ([])
    },
    filterFullList: {
      type: Array,
      default: () => ([])
    },
    filterInitList: {
      type: Array,
      default: () => ([])
    },
    printList: {
      type: Array,
      default: () => ([])
    },
    createList: {
      type: Array,
      default: () => ([])
    },
    updateList: {
      type: Array,
      default: () => ([])
    },
    createFormValues: {
      type: Object,
      default: () => ({})
    },
    filterByAlways: {
      type: Array,
      default: () => ([])
    },
    filterByInit: {
      type: Array,
      default: () => ([])
    },
    orderByInit: {
      type: Array,
      default: () => ([])
    },
    columnGroupBy: {
      type: Array,
      default: () => []
    },
    formLabelWidth: {
      type: Number,
      default: 140
    },
    tableWidth: {
      type: Number,
      default: 0
    },
    isExpand: Function,
    requestData: {
      type: Object,
      default: () => {
        return {}
      }
    } // dataTable 分页获取添加请求参数
  },
  data () {
    // 字段信息
    const columnsList = cloneDeep(this.columns)
    columnsList.serial = {
      label: '序号',
      width: 64,
      type: 'custom',
      customRender (data, full, index) {
        return index + 1
      }
    }
    const columnsKeys = Object.keys(columnsList)
    columnsKeys.map(key => {
      columnsList[key].width = columnsList[key].width || 200
    })
    const relationKeys = columnsKeys.filter(key => columnsList[key].relation).map(key => columnsList[key].relation)
    const that = this
    const filterBy = this.filterTextToFilterBy(this.$route.query.filterBy)
    const orderBy = this.orderTextToOrderBy(this.$route.query.orderBy)
    return {
      tableList: this.tableInitList,
      filterList: this.filterInitList,
      isFilterShow: !relationKeys.length,
      relationKeys: relationKeys,
      tableData: [],
      dialogVisible: false,
      columnsList: columnsList,
      filterBy: filterBy,
      orderBy: orderBy,
      treeExpands: new Set(),
      pageSize: Number(this.$route.query.pageSize) || 10,
      pageIndex: Number(this.$route.query.pageIndex) || 1,
      recordsFiltered: 0,
      recordsTotal: 0,
      isLoading: false,
      createButtonList: [{
        name: 'submit',
        label: '提交',
        type: 'complete',
        validate: true,
        funcProps: {
          table: this
        },
        func ({funcProps}) {
          const { form, button } = funcProps
          button.loading = true
          fetchCreate({
            resource: that.resource,
            data: form.formValues
          })
          .then(data => {
            button.loading = false
            if (data) {
              that.getData()
              that.dialogVisible = false
            }
          })
        }
      }],
      updateButtonList: [{
        name: 'submit',
        label: '提交',
        type: 'complete',
        validate: true,
        funcProps: {
          table: this
        },
        func ({funcProps}) {
          const { form, button } = funcProps
          button.loading = true
          fetchUpdate({
            resource: that.resource,
            id: form.formValues.id,
            data: form.formValues
          })
          .then(data => {
            button.loading = false
            if (data) {
              that.getData()
              that.dialogVisible = false
            }
          })
        } /* 编辑表单的提交事件 */
      }]
    }
  },
  watch: {
    '$route' (to) {
      const { pageIndex, pageSize, filterBy, orderBy } = to.query
      this.pageIndex = Number(pageIndex) || 1
      this.pageSize = Number(pageSize) || 10
      this.filterBy = this.filterTextToFilterBy(filterBy)
      this.orderBy = this.orderTextToOrderBy(orderBy)
      this.getData()
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.relationKeys.length ? this.getRelation() : this.getData()
  },
  computed: {
    ...mapGetters([
      'menuActive',
      'treeStorage',
      'clientWidth',
      'clientHeight'
    ]), /* navbar状态获取,影响table宽度 */
    tableWrapperWidth () {
      if (this.tableWidth) {
        return this.tableWidth
      }
      return this.clientWidth - (this.menuActive ? 210 : 0) - ((this.clientWidth > 991) ? 70 : 0) - 40
    }, /* 影响table宽度计算，和navbar状态相关 */
    dialogShow () {
      return this.dialogVisible
    }, /* 判断新增弹窗是否打开 */
    updateDialogShow () {
      return this.updateDialogVisible
    }, /* 判断编辑弹窗是否打开 */
    operationList () {
      return this.operation.map(item => {
        return {
          ...item,
          size: 'mini',
          funcProps: {
            ...item.funcProps,
            table: this
          }
        }
      })
    }, /* 计算table的操作列 */
    toolbarList () {
      return this.toolbar.map(item => {
        return {
          ...item,
          funcProps: {
            ...item.funcProps,
            table: this
          }
        }
      })
    } /* 计算table的工具栏toolbar */
  },
  methods: {
    changeOrderBy (data) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          orderBy: this.orderByToOrderText(data)
        }
      })
      // this.orderBy = data
      // this.getData()
    },
    // changeTreeExpands (data) {
    //   this.$router.push({
    //     path: this.$route.path,
    //     query: {
    //       ...this.$route.query,
    //       treeExpands: this.treeExpandsToTreeText(data)
    //     }
    //   })
      // this.orderBy = data
      // this.getData()
    // },
    changeFilterBy (data) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          filterBy: this.filterByToFilterText(data)
        }
      })
      // this.filterBy = [...data, ...this.filterByAlways]
      // this.getData()
    },
    getRelation (value) {
      this.isLoading = true
      fetch({
        url: '/relation',
        params: {
          relationList: this.relationKeys.join(',')
        }
      })
      .then((data) => {
        Object.keys(this.columnsList).map(key => {
          const relation = this.columnsList[key].relation
          if (data[relation]) {
            this.columnsList[key].options = [...this.columnsList[key].optionsInit || [], ...data[relation]].map(option => {
              const label = option[this.columnsList[key].labelName || 'label']
              const subtext = pinyinInitial(label)
              return {
                value: option.value !== undefined ? option.value : option.id,
                label,
                subtext,
                ...option
              }
            })
          }
        })
        this.isLoading = false
        this.isFilterShow = true
        this.$emit('getRelation', this.columnsList)
        this.getData()
      }).catch(() => {
        this.isLoading = false
      })
    }, /* 获取当前资源所关联的数据，并填到对应的列里 */
    pageSizeChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageSize: value
        }
      })
      this.pageIndexChange(1)
    }, /* 每页显示记录数的修改函数 */
    pageIndexChange (value) {
      this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          pageIndex: value
        }
      })
    }, /* 当前页码的修改函数 */
    getData () {
      this.$refs.dataTable.updateY(0)
      this.tableData = []
      const filterBy = [...this.filterBy, ...this.filterByAlways]
      if (!filterBy.length) return
      this.isLoading = true
      fetchList({
        resource: this.resource,
        orderBy: this.orderByToOrderText(this.orderBy),
        filterBy: this.filterByToFilterText(filterBy),
        pageSize: this.isTree ? 999999 : this.pageSize,
        pageIndex: this.isTree ? 1 : this.pageIndex,
        data: this.requestData
      })
      .then((data) => {
        this.isLoading = false
        const result = data || {
          data: [],
          recordsFiltered: 0,
          recordsTotal: 0
        }
        this.$emit('getData', result)
        this.tableRender({
          ...result
        })
      }).catch(() => {
        this.isLoading = false
      })
    }, /* 获取数据 */
    tableRender (data) {
      this.tableData = this.isTree ? treeFormat(data.data.map(item => ({
        ...item,
        isExpand: this.treeExpands.has(item.id)
      })), this.cid, this.pid) : data.data
      this.recordsFiltered = data.recordsFiltered
      this.recordsTotal = data.recordsTotal
    },
    afterChangeColumn (lists) {
      this.tableList = lists
    }, /* 列过滤 */
    filterByToFilterText (filterBy) {
      return filterBy.map(({name, type, value}) => `${name}|${type}|${value}`).join(';')
    },
    filterTextToFilterBy (filterText) {
      if (!filterText) {
        return []
      }
      return filterText.split(';').map(item => {
        const filter = item.split('|')
        return {
          name: filter[0],
          type: filter[1],
          value: valueFormat(filter[2], this.columnsList[filter[0]].dataType)
        }
      })
    },
    orderByToOrderText (orderBy) {
      const _orderBy = orderBy.length ? orderBy : [].concat(orderBy, this.orderByInit)
      return _orderBy.map(({name, sort}) => `${name}|${sort}`).join(';')
    },
    orderTextToOrderBy (orderText) {
      if (!orderText) {
        return []
      }
      return orderText.split(';').map(item => {
        const order = item.split('|')
        console.info('order:', order)
        return {
          name: order[0],
          sort: order[1]
        }
      })
    },
    changeTreeExpands ({recordIndex, id, isExpand}) {
      const data = this.currentData(this.tableData, recordIndex)
      data.isExpand = !data.isExpand
      data.isExpand ? this.treeExpands.add(id) : this.treeExpands.delete(id)
    },
    currentData (tableData, recordIndex) {
      if (recordIndex.length === 1) {
        return tableData[recordIndex[0]]
      } else {
        const newRecordIndex = recordIndex.slice(1, recordIndex.length)
        return this.currentData(tableData[recordIndex[0]].children, newRecordIndex)
      }
    },
    checkGroupValue (value) {
      this.$emit('checkGroupValue', value)
      this.valueCheckAll = value
    }
  }
}
</script>

<style scoped lang="sass">
.main
  padding: 20px
  // padding-top: 0px
  display: flex
  flex-direction: column
  flex: 1
  height: 100%
.table-wrapper
  display: flex
  flex-direction: column
  flex: 1
  position: relative
  z-index: 100
.table-fixed
  position: absolute
  right: 0
.table-top
  margin-bottom: 10px
  position: relative
  z-index: 200
  .toolbar
    float: left
    margin-right: 12px
  .filter-box
    float: right
    margin-left: 12px
  .customToolbar
    margin-bottom: 10px
.pagination
  flex: 1
  padding-top: 12px
  text-align: right
.column-filter
  float: left
  padding-top: 12px
.table-footer
  display: flex
  justify-content:  space-between
  align-item: center
  position: relative
  z-index: 100
</style>



// WEBPACK FOOTER //
// defined.vue?4d6930a3